import { produce } from "immer";
import { createReducer } from "typesafe-actions";
import { asyncActions } from "./actions.js";
import { fallbackActionId } from "./constants.js";
import { RequestStatus } from "./types.js";
const defaultState = {};
const producer = produce(
  (draftState, action, updatedState) => {
    const actionType = action.payload?.actionType;
    const actionId = action.payload?.actionId ?? fallbackActionId;
    if (actionType) {
      if (!draftState[actionType]) {
        draftState[actionType] = {};
      }
      if (!draftState[actionType][actionId]) {
        draftState[actionType][actionId] = {
          actionId,
          requestStatus: RequestStatus.None,
          isError: false,
          isNone: true,
          isProgress: false
        };
      }
      Object.assign(draftState[actionType][actionId], updatedState);
    }
    return draftState;
  }
);
const asyncActionsReducer = createReducer(defaultState).handleAction(
  asyncActions.setRequestStatus,
  (state, action) => producer(state, action, {
    requestStatus: action.payload.requestStatus,
    isError: action.payload.requestStatus === RequestStatus.Error,
    isNone: action.payload.requestStatus === RequestStatus.None,
    isProgress: action.payload.requestStatus === RequestStatus.Progress
  })
).handleAction(
  asyncActions.setErrorMessage,
  (state, action) => producer(state, action, {
    errorMessage: action.payload.errorMessage,
    errorMessageValues: action.payload.errorMessageValues
  })
).handleAction(
  asyncActions.setSuccessResponse,
  (state, action) => producer(state, action, {
    successfulResponse: action.payload.response
  })
).handleAction(asyncActions.clearAsyncActionsState, (state, action) => {
  const result = produce(state, (draftState) => {
    const actionType = action.payload?.actionType;
    if (actionType && draftState[actionType]) {
      const actionState = draftState[actionType];
      Object.entries(actionState).forEach(([id, idState]) => {
        if (idState?.requestStatus === RequestStatus.None) {
          delete draftState[actionType][id];
        }
      });
      if (Object.keys(actionState).length === 0) {
        delete draftState[actionType];
      }
    }
  });
  return result;
});
export {
  asyncActionsReducer
};
//# sourceMappingURL=reducers.js.map
